'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Owner$1(name, pet) {
  this.kb = null;
  this.kc = null;
  this.kb = name;
  this.kc = pet;
}
export { $c_Lsamples_Sealed$package$Owner$1 as $c_Lsamples_Sealed$package$Owner$1 };
$p = $c_Lsamples_Sealed$package$Owner$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Owner$1;
/** @constructor */
function $h_Lsamples_Sealed$package$Owner$1() {
}
export { $h_Lsamples_Sealed$package$Owner$1 as $h_Lsamples_Sealed$package$Owner$1 };
$h_Lsamples_Sealed$package$Owner$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-196521904), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Sealed$package$Owner$1)) {
    if ((this.kb === x$0.kb)) {
      var x = this.kc;
      var x$2 = x$0.kc;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Owner";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.kb;
  }
  if ((n === 1)) {
    return this.kc;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_Sealed$package$Owner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.er)));
}
export { $isArrayOf_Lsamples_Sealed$package$Owner$1 as $isArrayOf_Lsamples_Sealed$package$Owner$1 };
var $d_Lsamples_Sealed$package$Owner$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Owner$1, "samples.Sealed$package$Owner$1", ({
  er: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sealed$package$Owner$1 as $d_Lsamples_Sealed$package$Owner$1 };
